var _desc, _path, _path2, _path3, _ellipse, _ellipse2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirchainLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Airchain Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Airflow lines with linked chain")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 18c10-8 20-8 30 0",
    fill: "none",
    stroke: "#14F195",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 28c10-8 20-8 30 0",
    fill: "none",
    stroke: "#14F195",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 38c10-8 20-8 30 0",
    fill: "none",
    stroke: "#14F195",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30,
    cy: 38,
    rx: 10,
    ry: 8,
    fill: "none",
    stroke: "#9945FF",
    strokeWidth: 4
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 44,
    cy: 26,
    rx: 10,
    ry: 8,
    fill: "none",
    stroke: "#9945FF",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirchainLogo);
export default __webpack_public_path__ + "static/media/airchain-logo.235791cc3ab8c5ed77e5cfd137134644.svg";
export { ForwardRef as ReactComponent };